<div class="tizen-app-release-notes">
  <div class="tizen-app-release-notes__contents">
    <!-- ToDO: Add Release Notes logic -->
  </div>
</div>
